//// Application Configuration

//// Application Packages

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

// Translate Field (Utility)
export const minutesToMilliseconds = (string) => {
    if (string) {
        const minutes = parseInt(string)
        if (minutes) {
            const seconds = minutes * 60
            if (seconds) {
                const milliseconds = seconds * 1000
                if (milliseconds) {
                    return milliseconds
                } else {
                    return 0
                }
            } else {
                return 0
            }
        } else {
            return 0
        }
    } else {
        return 0
    }
}
